import React from "react";
import classNames from "classnames";

interface BodyHeadingProps {
  children: React.ReactNode;
  slim?: boolean;
}

export const BodyHeading: React.FC<BodyHeadingProps> = ({
  children,
  slim,
}: BodyHeadingProps) => {
  return (
    <div className="body__heading-container">
      <div
        className={classNames("body__heading", {
          "body__heading--slim": slim,
        })}
      >
        {children}
      </div>
    </div>
  );
};
